import React from 'react';
import { useSportGlossary } from '@/lib/useSportGlossary';

// Explains only the abbreviations a table actually shows, in the order shown.
export const StatLegend = ({ sport, codes, variant = 'screen', testId = 'stat-legend' }) => {
  const glossary = useSportGlossary(sport);
  const items = [...new Set(codes)].filter((c) => glossary[c]).map((c) => [c, glossary[c]]);
  if (!items.length) return null;
  if (variant === 'print') {
    return (
      <div className="stat-legend" data-testid={testId}>
        <span className="stat-legend-title">LEGEND</span>
        {items.map(([c, m]) => <span key={c} className="stat-legend-item"><b>{c}</b> {m}</span>)}
      </div>
    );
  }
  return (
    <div className="mt-6 rounded-xl border border-slate-200 bg-white px-4 py-3" data-testid={testId}>
      <p className="text-[10px] font-bold uppercase tracking-[0.14em] text-slate-400 mb-2">Stat legend</p>
      <dl className="grid grid-cols-1 min-[420px]:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-x-6 gap-y-1.5 text-xs">
        {items.map(([c, m]) => (
          <div key={c} className="flex gap-2" data-testid={`${testId}-${c}`}>
            <dt className="font-bold text-[#00247D] min-w-[2.75rem]">{c}</dt>
            <dd className="text-slate-600">{m}</dd>
          </div>
        ))}
      </dl>
    </div>
  );
};
